var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.errors.length)?_c('ul',_vm._l((_vm.errors),function(error,index){return _c('li',{key:index},[_c('strong',[_vm._v(_vm._s(error.dataPath))]),_vm._v("\n      "+_vm._s(error.message)+"\n      "+_vm._s(error.params)+"\n    ")])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"teaser-container"},_vm._l((_vm.teaserList),function(teaser,index){return _c(`bpb-extension-${
        [
          'article',
          'blog',
          'product',
          'event',
          'media',
          'collection',
          'keyword',
          'opinion',
        ].includes(teaser.meta.extension)
          ? teaser.meta.extension
          : 'basic'
      }`,{key:`${teaser.meta.id}-${index}`,tag:"component",attrs:{"data":teaser}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }